import * as React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import { init } from "@rematch/core";
import selectorsPlugin from "@rematch/select";

//import createReactRouterPlugin from "./plugin/createReactRouterPlugin";
import models from "./models/index";
// import App from "./App";
// import "./styles/index.less";
// import Routes from "./routes";

// import { Router } from "react-router";
import Page from "./Page";
import zhCN from "antd/lib/locale-provider/zh_CN";
// 加载moment 中文语言包
import "moment/locale/zh-cn";

import './styles/index.scss'
import "./styles/layout.scss";

const select = selectorsPlugin();

// 初始化store
const store = init({
  models: {
    ...models
  },
  plugins: [select]
});

render(
  <Provider store={store as any}>
    <ConfigProvider locale={zhCN}>
      <Page />
    </ConfigProvider>
  </Provider>,
  document.getElementById("root")
);
